import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'RemoveHTMLTagPipe'})
export class RemoveHTMLTagPipePipe implements PipeTransform {
  transform(str: string): any {
    return str.replace(/<.*?>/g, ' ');
  }
}
